import type { OperationVariables, MutationUpdaterFunction, ApolloCache, ApolloLink, TypedDocumentNode } from '@apollo/client'
import { TypedDocumentString } from 'nuxt-base/utils/apollo'

export function useGqlMutate<T, Vars extends OperationVariables>(
  mutationDocument: MyDocumentNode,
  inp: {
    clientId: 'get' | 'post'
    refetchQueries?: string[] | string | None
    vars: Vars
    update?: MutationUpdaterFunction<T, Vars, ApolloCache>
  }
): Promise<ApolloLink.Result<T>> {
  const refetchQueries: string[] | undefined = typeof inp.refetchQueries === 'string' ? [inp.refetchQueries] : Array.isArray(inp.refetchQueries) ? inp.refetchQueries : undefined
  return useApollo(inp.clientId)
    .mutate({
      mutation: TypedDocumentString.getQueryDocument(mutationDocument) as TypedDocumentNode<T, Vars>,
      variables: inp.vars,
      update: inp.update,
      refetchQueries: refetchQueries?.length ? refetchQueries : undefined,
    })
    .then((res) => res as ApolloLink.Result<T>)
}
